import {combineReducers, configureStore} from "@reduxjs/toolkit";

import showRequestAssistance from "shared/reduxElements/slices/showRequestAssistance";

import quoteInput from "./slices/quoteInput";
import quoteRequest from "./slices/quoteRequest";
import showApplyModal from "./slices/showApplyModal";


const rootReducer = combineReducers({
    quoteInput,
    quoteRequest,
    showRequestAssistance,
    showApplyModal,
});

export const store = configureStore({
    reducer: rootReducer,
});

